module.exports = __webpack_public_path__ + "assets/bd6309a880b5ed3d29138b7335451b03.png";